import {ModalActions} from "../constants/modalActions";
import {ToastActions} from "../constants/toastActions";

export const loginModal =  (type , callback) => dispatch => {

            dispatch({
                type: ModalActions.HANDLE_LOGIN_MODAL,
                payload: {loginModal: type}
            });
            callback()
        }
export const sideBar =  (open) => dispatch => {

            dispatch({
                type: ToastActions.SHOWSIDEBAR,
                payload: {openSide: open}
            });
        }

        export const settings =  (open) => dispatch => {

            dispatch({
                type: ModalActions.HANDLE_SETTINGS_MODAL,
                payload: {settings: open}
            });
        }





// WEBPACK FOOTER //
// ./src/actions/modalActions.tsx